<template>
  <div class="role-page">
    <div class="page-header">
      <h2 class="page-title">角色总表</h2>
      <button @click="openAddModal" class="add-btn">+ 添加角色</button>
    </div>

    <div class="filter-bar">
      <div class="search-box">
        <input
          type="text"
          v-model="searchKey"
          placeholder="搜索角色名称或编码..."
          class="search-input"
        />
        <select v-model="filterRoleType" class="filter-select">
          <option value="">全部类型</option>
          <option v-for="(label, val) in roleTypeMap" :key="val" :value="val">{{ label }}</option>
        </select>
        <select v-model="filterStatus" class="filter-select">
          <option value="">全部状态</option>
          <option value="1">启用</option>
          <option value="0">禁用</option>
        </select>
        <button @click="search" class="search-btn">搜索</button>
        <button @click="resetSearch" class="reset-btn">重置</button>
      </div>
    </div>

    <div class="table-container">
      <table class="role-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>角色名称</th>
            <th>角色编码</th>
            <th>角色类型</th>
            <th>数据权限</th>
            <th>角色描述</th>
            <th>权限数量</th>
            <th>排序</th>
            <th>状态</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in roles" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.code }}</td>
            <td>
              <span :class="'type-tag type-' + item.role_type">{{ roleTypeName(item.role_type) }}</span>
            </td>
            <td>{{ dataScopeName(item.data_scope) }}</td>
            <td class="desc-cell" :title="item.description">{{ item.description || '-' }}</td>
            <td>
              <span class="perm-count" :title="permTitle(item.permission_list)">
                {{ permCount(item.permission_list) }}
              </span>
            </td>
            <td>{{ item.sort_order == null ? '-' : item.sort_order }}</td>
            <td>
              <span :class="'status status-' + item.status">
                {{ item.status === 1 ? '启用' : '禁用' }}
              </span>
            </td>
            <td>{{ item.created_at || '-' }}</td>
            <td>
              <button @click="openEditModal(item)" class="action-btn edit">编辑</button>
              <button
                @click="toggleStatus(item)"
                class="action-btn"
                :class="item.status === 1 ? 'disable' : 'enable'"
              >
                {{ item.status === 1 ? '禁用' : '启用' }}
              </button>
              <button @click="handleDelete(item)" class="action-btn delete">删除</button>
            </td>
          </tr>
          <tr v-if="roles.length === 0">
            <td colspan="11" class="empty-cell">暂无数据</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <button :disabled="currentPage === 1" @click="currentPage--" class="page-btn">上一页</button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页（共 {{ total }} 条）</span>
      <button :disabled="currentPage === totalPages" @click="currentPage++" class="page-btn">下一页</button>
    </div>

    <!-- 新增 / 编辑弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ editingItem ? '编辑角色' : '添加角色' }}</h3>
          <button @click="closeModal" class="close-btn">×</button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group">
              <label>角色名称 <span class="required">*</span></label>
              <input v-model="form.name" type="text" class="form-control" placeholder="如：超级管理员 / 跑手" />
            </div>
            <div class="form-group">
              <label>角色编码 <span class="required">*</span></label>
              <input
                v-model="form.code"
                type="text"
                class="form-control"
                :disabled="editingItem"
                placeholder="如：admin_super / runner（唯一）"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>角色类型</label>
              <select v-model.number="form.role_type" class="form-control">
                <option v-for="(label, val) in roleTypeMap" :key="val" :value="Number(val)">{{ label }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>数据权限范围</label>
              <select v-model.number="form.data_scope" class="form-control">
                <option v-for="(label, val) in dataScopeMap" :key="val" :value="Number(val)">{{ label }}</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label>角色描述</label>
            <input v-model="form.description" type="text" class="form-control" placeholder="可选" />
          </div>
          <div class="form-group">
            <label>权限标识</label>
            <textarea
              v-model="form.permissionsText"
              class="form-control"
              rows="4"
              placeholder="多个权限用逗号分隔，如：dashboard:view,orders:view,user:users"
            ></textarea>
            <small class="form-tip">权限标识需为系统预定义合法标识，否则保存将失败。</small>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>排序</label>
              <input v-model.number="form.sort_order" type="number" min="0" class="form-control" placeholder="数字越小越靠前" />
            </div>
            <div class="form-group">
              <label>状态</label>
              <select v-model.number="form.status" class="form-control">
                <option :value="1">启用</option>
                <option :value="0">禁用</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModal" class="btn-cancel">取消</button>
          <button @click="save" class="btn-save">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getRoleList,
  createRole,
  updateRole,
  deleteRole
} from '@/api/role'

export default {
  name: 'RoleList',
  data() {
    return {
      searchKey: '',
      filterRoleType: '',
      filterStatus: '',
      currentPage: 1,
      pageSize: 20,
      totalPages: 1,
      total: 0,
      roles: [],
      showModal: false,
      editingItem: null,
      roleTypeMap: {
        1: '后台管理员',
        2: '前台用户',
        3: '分佣角色',
        4: '平台级'
      },
      dataScopeMap: {
        0: '全部',
        1: '本人',
        2: '本社区',
        3: '本租户',
        4: '自定义'
      },
      form: this.emptyForm()
    }
  },
  watch: {
    currentPage() {
      this.loadList()
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    emptyForm() {
      return {
        name: '',
        code: '',
        role_type: 2,
        data_scope: 1,
        description: '',
        permissionsText: '',
        sort_order: 0,
        status: 1
      }
    },
    async loadList() {
      try {
        const params = {
          page: this.currentPage,
          per_page: this.pageSize
        }
        const keyword = this.searchKey.trim()
        if (keyword) params.keyword = keyword
        if (this.filterRoleType !== '') params.role_type = Number(this.filterRoleType)
        if (this.filterStatus !== '') params.status = Number(this.filterStatus)

        const res = await getRoleList(params)
        if (res && res.code === 0) {
          this.roles = res.data || []
          this.total = res.total || 0
          this.totalPages = Math.max(1, Math.ceil(this.total / (res.per_page || this.pageSize)))
        }
      } catch (error) {
      }
    },
    search() {
      this.currentPage = 1
      this.loadList()
    },
    resetSearch() {
      this.searchKey = ''
      this.filterRoleType = ''
      this.filterStatus = ''
      this.currentPage = 1
      this.loadList()
    },
    roleTypeName(type) {
      return this.roleTypeMap[type] || ('未知(' + type + ')')
    },
    dataScopeName(scope) {
      return this.dataScopeMap[scope] != null ? this.dataScopeMap[scope] : '-'
    },
    permCount(list) {
      return Array.isArray(list) ? list.length : 0
    },
    permTitle(list) {
      return Array.isArray(list) && list.length ? list.join(', ') : ''
    },
    openAddModal() {
      this.editingItem = null
      this.form = this.emptyForm()
      this.showModal = true
    },
    openEditModal(item) {
      this.editingItem = item
      this.form = {
        name: item.name || '',
        code: item.code || '',
        role_type: item.role_type == null ? 2 : Number(item.role_type),
        data_scope: item.data_scope == null ? 1 : Number(item.data_scope),
        description: item.description || '',
        permissionsText: Array.isArray(item.permission_list) ? item.permission_list.join(', ') : '',
        sort_order: item.sort_order == null ? 0 : item.sort_order,
        status: item.status == null ? 1 : Number(item.status)
      }
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.editingItem = null
      this.form = this.emptyForm()
    },
    async save() {
      if (!this.form.name.trim()) {
        alert('请输入角色名称')
        return
      }
      if (!this.form.code.trim()) {
        alert('请输入角色编码')
        return
      }

      const permissions = this.form.permissionsText
        .split(',')
        .map(s => s.trim())
        .filter(s => s !== '')

      const payload = {
        name: this.form.name.trim(),
        code: this.form.code.trim(),
        role_type: this.form.role_type,
        data_scope: this.form.data_scope,
        description: this.form.description.trim(),
        permissions,
        sort_order: this.form.sort_order,
        status: this.form.status
      }

      try {
        if (this.editingItem) {
          await updateRole(this.editingItem.id, payload)
          alert('更新成功')
        } else {
          await createRole(payload)
          alert('添加成功')
        }
        this.closeModal()
        this.loadList()
      } catch (error) {
        const msg = error && error.response && error.response.data && error.response.data.message
        alert(msg || '保存失败，请稍后重试')
      }
    },
    async toggleStatus(item) {
      const action = item.status === 1 ? '禁用' : '启用'
      if (confirm(`确定要${action}角色 ${item.name} 吗？`)) {
        try {
          const newStatus = item.status === 1 ? 0 : 1
          await updateRole(item.id, { status: newStatus })
          item.status = newStatus
        } catch (error) {
          alert('更新状态失败')
        }
      }
    },
    async handleDelete(item) {
      if (confirm(`确定要删除角色 ${item.name} 吗？此操作不可恢复。`)) {
        try {
          await deleteRole(item.id)
          alert('删除成功')
          this.loadList()
        } catch (error) {
          alert('删除失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.role-page {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.filter-bar {
  margin-bottom: 16px;
  padding: 14px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.search-box {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.search-input,
.filter-select {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}

.search-input {
  width: 280px;
}

.search-btn,
.reset-btn {
  padding: 10px 18px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.search-btn {
  background: #3498db;
  color: #fff;
}

.reset-btn {
  background: #ecf0f1;
  color: #333;
}

.add-btn {
  padding: 10px 20px;
  background: #2ecc71;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.table-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.role-table {
  width: 100%;
  border-collapse: collapse;
}

.role-table th,
.role-table td {
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid #eee;
  font-size: 13px;
}

.role-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
}

.desc-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.perm-count {
  display: inline-block;
  min-width: 24px;
  padding: 2px 8px;
  border-radius: 10px;
  background: #eef2ff;
  color: #4f46e5;
  text-align: center;
  font-size: 12px;
}

.type-tag {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.type-1 { background: #e8eaf6; color: #3f51b5; }
.type-2 { background: #e0f2f1; color: #00897b; }
.type-3 { background: #fff3e0; color: #ef6c00; }
.type-4 { background: #fce4ec; color: #c2185b; }

.empty-cell {
  text-align: center;
  color: #999;
  padding: 30px 0;
}

.status {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
}

.status-1 { background: #e8f5e9; color: #2ecc71; }
.status-0 { background: #ffebee; color: #e74c3c; }

.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  margin-right: 5px;
  color: #fff;
}

.action-btn.edit { background: #3498db; }
.action-btn.disable { background: #e74c3c; }
.action-btn.enable { background: #2ecc71; }
.action-btn.delete { background: #95a5a6; }

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  width: 600px;
  max-width: 92%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
}

.close-btn {
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
}

.modal-body {
  padding: 20px;
}

.form-row {
  display: flex;
  gap: 16px;
}

.form-row .form-group {
  flex: 1;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.required {
  color: #e74c3c;
}

.form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-tip {
  display: block;
  margin-top: 6px;
  color: #999;
  font-size: 12px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 20px;
  border-top: 1px solid #eee;
}

.btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.btn-save {
  padding: 8px 16px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
